"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.getDefaultValue = exports.cookie = void 0;

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var cookie = function cookie(key, value) {
  if (value === null) {
    _jsCookie["default"].remove(key);
  } else if (value !== undefined) {
    _jsCookie["default"].set(key, value);
  } else {
    return _jsCookie["default"].get(key);
  }
};

exports.cookie = cookie;

var getDefaultValue = function getDefaultValue(cookieKey, defaultValue) {
  var cookieValue = cookieKey && cookie(cookieKey);

  if (typeof cookieValue !== 'undefined') {
    return cookieValue;
  }

  return typeof defaultValue !== 'undefined' ? defaultValue : '';
};

exports.getDefaultValue = getDefaultValue;